module.exports = __webpack_public_path__ + "img/mg.6103c4ef.svg";